var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"is-waiting-overlay-ma"},[_c('div',{staticClass:"inner"},[_c('p',[_vm._v("Please wait")]),_vm._v(" "),_c('transition',{attrs:{"name":"fade-fast"}},[_c('ThreeDots',{attrs:{"color":"#ffffff"}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12852c6a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/isWaitingMA.vue
// module id = null
// module chunks = 